import { useEffect } from "react";

import { JiraProductDiscoveryPricingPageTemplate } from "@/templates/software/jira/product-discovery/jira-product-discovery-software-page/pricing/jira-product-discovery-pricing-page/src/jira-product-discovery-pricing-page.template";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";

import { PricingContentContextProvider } from "../../../../../components/wpl/pricing/src/pricing-content-context.tsx";
import { AppPricingData } from "../../../../../contentful";
import { UserLocale } from "../../../../../utils/useGeoCurrency";

import { getPricingTitleInternal } from "./feature-gates.ts";

export type JiraProductDiscoveryPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
};

export const JiraProductDiscoveryPricingPage = ({
    pricing,
    countryCode,
    pricingContent
}: JiraProductDiscoveryPricingPageProps) => {
    const pricingTitleInternal = getPricingTitleInternal();

    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProvider
            productId="jira-product-discovery"
            pricingTitleInternal={pricingTitleInternal}
            pricingContent={pricingContent}
        >
            <div data-testid="jpd-pricing-page">
                <JiraProductDiscoveryPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProvider>
    );
};
